// 警告メッセージ(web操作の継続可)
export const warnEwbConnecting = (deviceName: string) => `eWhiteboard [${deviceName}] と接続中...`
export const warnEwbFetching = (deviceName: string) => `eWhiteboard [${deviceName}] からデータを取得しています...`
export const warnEwbUnavailable = (deviceName: string) => `eWhiteboard [${deviceName}] から応答がありません。表示されている情報と異なる可能性があります。`
export const warnEwbConnectRetry = (deviceName: string) => [`接続に時間がかかっています。`, `eWhiteboard [${deviceName}] の状態を確認してください。`]
export const warnServerDisconnected = `サーバーとの通信エラーが発生しました`
export const warnServerConnecting = `サーバーと接続中...`
export const warnNWError = (deviceName: string) => `${deviceName}との通信が不安定です。入力内容が保存されない可能性があります`;

// エラーメッセージ(web操作の継続不可)
export const errDocNotFound = (deviceName: string) => `${deviceName}に選択した文書が存在しません。削除されていないか確認してください`
export const errEwbDisconnected = (deviceName: string) => `eWhiteboard [${deviceName}] との接続ができません`
export const errUndefined = `不明なエラーが発生しました。ブラウザを更新してください`;

// 警告ダイアログメッセージ
export const warnConflict = [`このまま画面を移動すると、競合した内容が保存されません。`, `移動してもよろしいですか？`];
export const warnEditing = [`このまま画面を移動すると、編集した内容が保存されません。`, `移動してもよろしいですか？`];